import darkianLogo from '../assets/darkian.png';
import { navLinks } from '../data/content';
import useTheme from '../hooks/useTheme';
import Logo from './Logo';
import './Footer.css';

export default function Footer() {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <footer className="footer pin-dark">
      <div className="footer__top">
        <div>
          <div className="footer__brand">
            <Logo size={40} className="footer__mark" />
            <div className="footer__wordmark">
              <div className="footer__eyebrow">CENTRO DE ENTRENAMIENTO</div>
              <div className="footer__name">KAMAE</div>
            </div>
          </div>
          <p className="footer__about">
            Escuela de Karate Do Shito Ryu en Cúcuta. Disciplina, respeto y
            tradición en el camino del guerrero.
          </p>
        </div>

        <div>
          <div className="footer__heading">Navegación</div>
          <div className="footer__nav">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="footer__link">
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__appearance">
          <div className="footer__heading">Apariencia</div>
          <button
            type="button"
            className="footer__theme-toggle"
            onClick={toggleTheme}
          >
            <span className="footer__theme-icon">{isLight ? '◐' : '◑'}</span>
            <span>{isLight ? 'Modo oscuro' : 'Modo claro'}</span>
          </button>
        </div>
      </div>

      <div className="footer__powered">
        <a
          href="https://darkian.co"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Sitio web diseñado por Darkian"
          className="footer__powered-link"
        >
          <span className="footer__powered-label">Powered by</span>
          <img src={darkianLogo} alt="Darkian" className="footer__powered-logo" />
          <span className="footer__powered-arrow">↗</span>
        </a>
      </div>

      <div className="footer__bottom">
        <span className="footer__copy">
          © 2026 Centro de Entrenamiento Kamae. Todos los derechos
          reservados.
        </span>
        <span className="footer__kanji-trio">構 · 道 · 礼</span>
      </div>
    </footer>
  );
}